import styled from 'styled-components';
import { fontSize, screen } from 'theme';
import FlexibleWrapper from 'components/shared/FlexibleWrapper/FlexibleWrapper';
import { Button, ButtonLink } from '@asgard/ui-library';

const Root = styled.div`
  background-color: var(--surface-auxiliary-3-level-02-background, #d3d9f3);
  color: #092c61;

  padding: 4rem 0 5rem 0;
  font-size: ${fontSize('lg')};
  min-height: 600px;
  overflow: hidden;

  .titles {
    flex-direction: column-reverse;
  }
`;

const OuterWrapper = styled(FlexibleWrapper).attrs({
  imagePath: '/images/common/irregular-box-4.svg',
  backgroundColor: 'var(--surface-auxiliary-3-level-02-background, #B0B7E7)'
})`
  margin: auto 1rem;
  padding: 3rem 4rem 3rem 3rem;

  @media (max-width: ${screen('md2')}) {
    padding-bottom: clamp(4rem, 5vw, 6rem);
  }
`;

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-height: 500px;
  max-width: 100%;
  margin: 2rem auto 0;

  color: var(--content-on-auxiliary-3-text, #0a053a);
  text-align: center;
  justify-content: center;

  & > *:first-child {
    order: 1;
  }
  & > *:nth-child(2) {
    order: 0;
  }

  p {
    margin: 0;
  }

  h1 {
    font-size: clamp(${fontSize('xl2')}, 2vw, ${fontSize('xl3')});
    font-weight: 800;
    text-wrap: balance;
    margin: 0 0 1.5rem 0;
  }

  img {
    display: block;
    margin: 0 auto;
    max-width: 100%;
    height: auto;
  }

  br {
    display: none;
  }

  @media (min-width: ${screen('md2')}) {
    flex-direction: row;
    align-items: center;
    gap: var(--gap-components-gutter, 32px);
    max-width: 100%;
    margin: 0;

    & > * {
      flex: 1;
      min-width: 0;
    }
    & > *:first-child {
      order: 0;
    }
    & > *:nth-child(2) {
      order: 1;
    }

    br {
      display: block;
    }
  }

  @media (min-width: ${screen('xl')}) {
    text-align: left;

    h1 {
      font-size: clamp(${fontSize('xl3')}, 3vw, ${fontSize('xl5')});
      margin-top: 3rem;
    }
  }
`;

const CTAs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: ${screen('xl')}) {
    flex-direction: row;
  }
`;

const StyledButtonLink = styled(ButtonLink)`
  & > span:last-child > span {
    white-space: normal;
    font-size: clamp(${fontSize('xs')}, 1.2vw, ${fontSize('sm')});
  }
`;

const TemporalDisabledButton = styled(Button)`
  text-align: left;
  & > span:last-child > span {
    white-space: normal;
    font-size: clamp(${fontSize('xs')}, 1.2vw, ${fontSize('sm')});
  }
`;

export const HeroStyles = {
  Root,
  OuterWrapper,
  Content,
  CTAs,
  StyledButtonLink,
  TemporalDisabledButton
};
